import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AppHeader } from "@/components/AppHeader";
import { useAppSettings } from "@/lib/settings";
import { Send, UserCircle2, ChevronLeft, MessageCircle } from "lucide-react";

export const Route = createFileRoute("/_authenticated/help")({ component: HelpPage });

function stripAt(u: string) {
  return (u || "").trim().replace(/^@/, "").replace(/^https?:\/\/t\.me\//i, "");
}

function HelpPage() {
  const navigate = useNavigate();
  const { data: settings } = useAppSettings();
  const admin = stripAt(settings?.telegram?.admin_username ?? "");
  const channel = stripAt(settings?.telegram?.channel_username ?? "");

  return (
    <div>
      <AppHeader />
      <div className="gradient-header px-4 pb-6 -mt-1">
        <button onClick={() => navigate({ to: "/" })} className="mb-3 flex items-center gap-1 text-sm font-semibold text-white/90">
          <ChevronLeft className="h-4 w-4" /> Back
        </button>
        <div className="flex items-center gap-3 text-primary-foreground">
          <div className="grid h-12 w-12 place-items-center rounded-2xl bg-white/15 backdrop-blur">
            <Send className="h-6 w-6" />
          </div>
          <div>
            <p className="text-xl font-black">Help & Support</p>
            <p className="text-xs text-white/80">Reach us on Telegram</p>
          </div>
        </div>
      </div>

      <div className="space-y-3 px-4 py-4">
        {!admin && !channel && (
          <div className="rounded-2xl bg-card p-6 text-center shadow-card">
            <MessageCircle className="mx-auto h-8 w-8 text-muted-foreground" />
            <p className="mt-2 text-sm font-semibold">Support links not configured yet</p>
            <p className="mt-1 text-xs text-muted-foreground">Please check back shortly.</p>
          </div>
        )}

        {admin && (
          <a
            href={`https://t.me/${admin}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 rounded-2xl bg-card p-4 shadow-card active:scale-[0.99]"
          >
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-[#229ED9]/15 text-[#229ED9]">
              <UserCircle2 className="h-6 w-6" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold">Help / Admin</p>
              <p className="truncate text-xs text-muted-foreground">@{admin}</p>
            </div>
            <span className="rounded-full bg-[#229ED9] px-3 py-1 text-[11px] font-bold text-white">Chat</span>
          </a>
        )}

        {channel && (
          <a
            href={`https://t.me/${channel}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 rounded-2xl bg-card p-4 shadow-card active:scale-[0.99]"
          >
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-[#229ED9]/15 text-[#229ED9]">
              <Send className="h-6 w-6" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold">Telegram Channel</p>
              <p className="truncate text-xs text-muted-foreground">@{channel}</p>
            </div>
            <span className="rounded-full bg-[#229ED9] px-3 py-1 text-[11px] font-bold text-white">Join</span>
          </a>
        )}
      </div>
    </div>
  );
}
